import { render } from "./Course_Item.vue?vue&type=template&id=ce07dc4e"
import script from "./Course_Item.vue?vue&type=script&lang=js"
export * from "./Course_Item.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__